module.exports = {

  bulkupload: ($stateParams, Api) ->
    offset = ($stateParams.page - 1) * 10
    return Api.BulkUpload.query({'offset': offset}).$promise

}
